/**
 * Handler for collapsing/expanding content sections.
 *
 * Expected DOM structure:
 *
 * ```
 *   <section data-collapsible-block>
 *     <a data-collapsible-block-link></a>
 *     <!-- Content -->
 *   </section>
 *
 * See: templates/shared/collapsible_block.ego
 * See: assets/stylesheets/site/blocks/_collapsible-block.scss
 */
class CollapsibleBlock {
  constructor(el) {
    this.el = el;
    this.toggle = this.el.querySelector('[data-collapsible-block-link]');

    this.el.setAttribute('data-collapsible-block-enabled', '');
    this.toggle.addEventListener('click', this.click.bind(this));
  }

  click(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.isClosed()) {
      this.open(true);
    } else {
      this.close();
    }
  }

  isClosed() {
    return this.el.classList.contains('collapsible-block--closed');
  }

  open(shouldFocus) {
    this.el.classList.remove('collapsible-block--closed');
    this.el.classList.add('collapsible-block--open');

    const svg = this.el.querySelector('svg');
    if (svg) {
      svg.classList.remove('icon-link__svg--90');
      svg.classList.add('icon-link__svg--270');
    }

    let labelText = this.el.getAttribute('aria-label');
    if (labelText) {
      this.el.setAttribute('aria-label', labelText.replace('Open', 'Close'));
    }
    this.toggle.setAttribute('aria-expanded', 'true');

    if (shouldFocus) {
      this.toggle.focus();
    }
  }

  close() {
    this.el.classList.add('collapsible-block--closed');
    this.el.classList.remove('collapsible-block--open');

    const svg = this.el.querySelector('svg');
    if (svg) {
      svg.classList.add('icon-link__svg--90');
      svg.classList.remove('icon-link__svg--270');
    }

    let labelText = this.el.getAttribute('aria-label');
    if (labelText) {
      this.el.setAttribute('aria-label', labelText.replace('Close', 'Open'));
    }
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collapsible-block]:not([data-collapsible-block-enabled])').forEach(el => {
    new CollapsibleBlock(el);
  });
});

export { CollapsibleBlock };
